import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chart.js/auto';
import { fetchTicketsNonTSA } from '../chartsAPI/jiraApi'; 

const CdwCRM = () => {
  const [projectKey, setProjectKey] = useState('AC'); // Replace with the appropriate CDW project key
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchTicketsNonTSA(projectKey);
        //console.log('Fetched tickets:', data);
        setTickets(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [projectKey]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const statusOrder = [
    "To Do", "APPROVED FOR WORK", "IN PROGRESS AXILLON","In Progress Axillon", "IN PROGRESS CDW",
    "AXILLON TESTING", "CDW TESTING", "READY TO DEPLOY", "DEPLOYED TO PRODUCTION", "BLOCKED"
  ];

  const statusColors = {
    "To Do": "#e74c3c",
    "APPROVED FOR WORK": "#f39c12",
    "IN PROGRESS AXILLON": "#3498db",
    "In Progress Axillon": "#3498db",
    "IN PROGRESS CDW": "#5DADE2",
    "AXILLON TESTING": "#9b59b6",
    "CDW TESTING": "#8e44ad",
    "READY TO DEPLOY": "#2ecc71",
    "DEPLOYED TO PRODUCTION": "#27ae60",
    "BLOCKED": "#e67e22",
  };

  const sortedTickets = tickets.sort((a, b) => {
    const indexA = statusOrder.indexOf(a.status);
    const indexB = statusOrder.indexOf(b.status);
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  const labels = sortedTickets.map(ticket => ticket.status);
  const dataValues = sortedTickets.map(ticket => ticket.count);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Tickets by Status',
        data: dataValues,
        backgroundColor: labels.map(status => statusColors[status] || "#bdc3c7"),
        borderColor: "#000",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: 'end',
        align: 'right',
        formatter: value => value,
        font: {
          weight: 'bold',
          size: 14,
        },
        color: '#000',
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: { display: false },
      },
      y: {
        grid: { display: false },
      },
    },
  };

  return (
    <div style={{ height: '400px' }}>
      <Bar data={chartData} options={chartOptions} plugins={[ChartDataLabels]} />
    </div>
  );
};

export default CdwCRM;